module.exports = __webpack_public_path__ + "static/media/500R.6525a00.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/500R.mp3
// module id = aRAB
// module chunks = 1